import { render, staticRenderFns } from "./view-serial-history.vue?vue&type=template&id=6e2dc37a&"
import script from "./view-serial-history.vue?vue&type=script&lang=js&"
export * from "./view-serial-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports